import EvaluationBadge from './EvaluationBadge'

export default EvaluationBadge
